import { Lightning, Drop, Flame, Globe, Cube, Truck, Gear, Leaf, Package } from '@phosphor-icons/react';

export function datasetTone(name = '') {
    const text = name.toLowerCase();
    return /water|wastewater/.test(text) ? 'blue'
        : /grid|electric|energy/.test(text) ? 'amber'
        : /fuel|transport|freight/.test(text) ? 'orange'
        : /process|manufactur/.test(text) ? 'teal'
        : /gwp|climate|regional|reference/.test(text) ? 'violet'
        : /product|packag|textile/.test(text) ? 'rose' : 'green';
}

export default function DatasetIcon({name = ''}) {
    const text = name.toLowerCase();
    const Icon = /water|wastewater/.test(text) ? Drop
        : /grid|electric|energy/.test(text) ? Lightning
        : /fuel/.test(text) ? Flame
        : /transport|freight/.test(text) ? Truck
        : /process|manufactur/.test(text) ? Gear
        : /gwp|climate|regional|reference/.test(text) ? Globe
        : /bio|wood|recycl/.test(text) ? Leaf
        : /product|packag/.test(text) ? Package : Cube;
    return <Icon size={22} weight="duotone" aria-hidden="true"/>;
}
